<template>
  <div class="section group">
    <b-card no-body>
      <b-tabs pills card vertical>
        <b-tab title-item-class="mytab" :title="$t('changePassword')" :active="true">
          <b-card-text><ChangePassword /></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import ChangePassword from '../components/common/ChangePassword'

export default {
metaInfo() {
    return {
      title: this.$i18n.t('settings'),
    }
  },
  components: {
    ChangePassword
  }
}
</script>

<style lang="css">
 .nav-pills .mytab .nav-link:not(.active) {
    color: var(--primary);
  }

  .nav-pills .mytab .nav-link {
    background-color: var(--primary) !important;
  }

  .tab-content > .tab-pane {
    border: 1px solid;
    border-left: 0px none;
  }
  .nav-pills .mytab .nav-link :hover {
    color: var(--bg) !important;
  }
  .tab-content > .tab-pane {
    border: none;
  }
</style>